import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { Reveal } from "../Reveal";
import { REVIEWS, EXTERNAL } from "../../lib/site";

export const Reviews = () => (
  <section id="reviews" className="bg-white py-24 md:py-32" data-testid="reviews">
    <div className="max-w-7xl mx-auto px-6 md:px-8">
      <Reveal>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#d90429]">What travelers say</span>
            <h2 className="mt-3 font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-[#0b192c] tracking-tight">
              Trusted by thousands of<br className="hidden sm:block" /> DC-area travelers.
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex">{[0,1,2,3,4].map(i => <Star key={i} className="w-5 h-5 fill-[#f5b301] text-[#f5b301]" />)}</div>
            <span className="font-display font-black text-2xl text-[#0b192c]">4.9</span>
            <a href={EXTERNAL.google} target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-[#d90429] hover:underline" data-testid="reviews-google-link">on Google & Yelp</a>
          </div>
        </div>
      </Reveal>

      <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {REVIEWS.map((r, i) => (
          <motion.figure
            key={r.name}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.55, delay: i * 0.08 }}
            className="bg-[#f8f9fa] rounded-2xl p-7 border border-black/5 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(11,25,44,0.10)] transition-[transform,box-shadow] duration-300"
            data-testid={`review-${i}`}
          >
            <Quote className="w-8 h-8 text-[#d90429]/30" />
            <div className="flex mt-3 mb-4">{[0,1,2,3,4].map(s => <Star key={s} className="w-4 h-4 fill-[#f5b301] text-[#f5b301]" />)}</div>
            <blockquote className="text-[15px] text-slate-700 leading-relaxed">{r.text}</blockquote>
            <figcaption className="mt-5 pt-4 border-t border-slate-200 flex items-center justify-between">
              <span className="font-semibold text-[#0b192c]">{r.name}</span>
              <span className="text-xs text-slate-500">via {r.source}</span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
